import { Directive, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { PaypalExpressService } from '@df/module-paypal/paypal-express.service';
import { Paypal } from '@df/module-paypal/paypal.namespace';
import { UiComponent } from '@df/ui/ui.component';
import { NDfModulePaypal } from './df-module-paypal.config';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class PaypalExpressButtonComponentDef extends UiComponent implements OnInit {
    status = new Status();
    fundingSource?: string;
    constructor(
        private paypalExpressService: PaypalExpressService,
        private router: Router,
        private app: App,
        @Inject(NDfModulePaypal.OPTIONS) private dfPaypalConfig: NDfModulePaypal.IModuleOptions
    ) {
        super();
        // Loading Paypal SDK
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
        this.paypalExpressService.loadSDK(this.status).then((buttonConfig: Paypal.ISDKButtonConfig) => {
            const buttons = this.paypalExpressService.getButtons();
            if (buttons) {
                // by calling buttons we create paypal button using external Paypal script
                buttons({
                    // Paypal button styles are loaded from BE as well, those styles are set in paypal settings
                    style: buttonConfig.styles,
                    // createOrder is called on button click, while external paypal window is opened
                    // we get token from BE and provide it to Paypal.
                    createOrder: () => this.paypalExpressService.getToken(this.status),
                    // Once all the information and payment is confirmed on Paypal side, we authorise it here.
                    onApprove: data => {
                        this.paypalExpressService.authorise(
                            this.status,
                            { paymentToken: data.orderID, payerID: data.payerID, paypalFundingSource: this.fundingSource },
                            () => {
                                this.router.navigateByUrl(this.dfPaypalConfig.review_path);
                            }
                        );
                    },
                    // Here we receive funding source needed for authorisation.
                    onClick: (data: Paypal.ISDKButtonOnClickResult) => {
                        this.onButtonClick(data);
                        this.fundingSource = data.fundingSource;
                    }
                }).render('#paypal-express-button');
            }
        });
    }

    protected onButtonClick(data: Paypal.ISDKButtonOnClickResult) {
        // method to override if you want to track click
    }
}
